import renewAccessToken from './renewAccessToken';
import axios from 'axios';

export const authenticatedAxios = axios.create({
  headers: {
    Accept: 'application/json; charset=UTF-8',
  },
  // 40 seconds seems reasonable for waiting on a network request.
  // It's fairly high to allow for very slow apis to be usable.
  timeout: 40000,
  withCredentials: true,
  validateStatus(status) {
    const ok = status >= 200 && status < 300;
    const refreshTokenAndRetry = status === 401;
    return ok || refreshTokenAndRetry;
  },
});

authenticatedAxios.interceptors.request.use((config) => {
  // Dynamically add the most up-to-date hash key
  // if the authorization is set in the headers then use it
  config.headers.Authorization = config.headers.Authorization
    ? config.headers.Authorization
    : '';
  return config;
});

authenticatedAxios.interceptors.response.use((response) => {
  if (response.status === 401 && !response.config.disableAuthRefresh) {
    // renewAccessToken() will reload the page, so no need to retry the request afterwards
    return renewAccessToken();
  }
  return response;
});

function retryRequest(response) {
  return authenticatedAxios(
    Object.assign({}, response.config, {
      disableAuthRefresh: true,
    })
  );
}

export function axiosXhr(options) {
  return authenticatedAxios(options).then((r) => r.data);
}

export function axiosXhrCancelable(options) {
  const cancelTokenSource = axios.CancelToken.source();
  const cancelableOptions = {
    ...options,
    cancelToken: cancelTokenSource.token,
  };
  return {
    axiosXhr: axiosXhr(cancelableOptions),
    cancelTokenSource,
  };
}

export const isAxiosXhrCancel = (err) => axios.isCancel(err);
